"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiSelect = void 0;
const icons_1 = require("client/components/icons");
const menu_1 = require("client/components/menu");
const text_field_1 = require("client/components/ui/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./select.less");
let UiSelect = class UiSelect extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showMenu = false;
        this.searchValue = "";
        this.selectedValue = "";
        this.handleOnChange = (event) => {
            const { value } = event.target;
            this.searchValue = value;
            this.props.onSearch && this.props.onSearch(this.searchValue);
        };
    }
    get filteredOptions() {
        return this.props.options
            ? this.props.options.filter(o => o.label.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1)
            : [];
    }
    componentWillMount() {
        const match = this.props.options.find(o => o.value === this.props.value);
        this.searchValue = match ? match.label : "";
        this.selectedValue = this.props.value || "";
    }
    componentWillReceiveProps(props) {
        // If the value changed from the parent
        if (this.selectedValue !== props.value ||
            (!this.props.onSearch && this.props.options !== props.options)) {
            const match = this.props.options.find(o => o.value === this.props.value);
            this.searchValue = match ? match.label : "";
            this.selectedValue = this.props.value || "";
        }
    }
    render() {
        const { className, label, options, required = false } = this.props;
        return (React.createElement("div", { className: "ui-select" },
            React.createElement(menu_1.Menu, { className: className, data: this.props.onSearch ? this.props.options : this.filteredOptions, showMenu: this.showMenu, onAction: item => {
                    if (item) {
                        // If an item was selected by user then update it
                        this.searchValue = item.label;
                        this.selectedValue = item.value;
                        this.props.onSelect && this.props.onSelect(this.selectedValue);
                    }
                    else {
                        // If no item was selected by user then check if searched value is valid option
                        const selectedOption = options &&
                            options.find(o => o.label.toLowerCase() === this.searchValue.toLowerCase());
                        if (selectedOption) {
                            // If it's valid update the selected item
                            this.searchValue = selectedOption.label;
                            this.selectedValue = selectedOption.value;
                            this.props.onSelect && this.props.onSelect(this.selectedValue);
                        }
                        else {
                            // Otherwise revert the search value to the selected value b/c user has left the input
                            const match = this.props.options.find(o => o.value === (this.props.value || ""));
                            this.searchValue = match ? match.label : this.selectedValue;
                        }
                    }
                    this.showMenu = false;
                } },
                React.createElement("a", { className: "menu-component__input" },
                    React.createElement(text_field_1.UiTextField, { className: className, label: label, required: required, rightItem: React.createElement(icons_1.Chevron, null), value: this.searchValue, onFocus: () => {
                            this.searchValue = "";
                            this.showMenu = true;
                            this.props.onSearch && this.props.onSearch(this.searchValue);
                        }, onChange: this.handleOnChange })))));
    }
};
__decorate([
    mobx_1.computed
], UiSelect.prototype, "filteredOptions", null);
__decorate([
    mobx_1.observable
], UiSelect.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], UiSelect.prototype, "searchValue", void 0);
__decorate([
    mobx_1.observable
], UiSelect.prototype, "selectedValue", void 0);
UiSelect = __decorate([
    mobx_react_1.observer
], UiSelect);
exports.UiSelect = UiSelect;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/select/select.tsx
// module id = 2701
// module chunks = 0 1